import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { RegisterCertification } from 'shell/models/register-certification';
import Form, {
  RegisterCertificationForm,
} from 'front-office/components/register-certification/form';
import { RegisterCertificationCrumbs } from 'front-office/constants/register-certification-crumbs';
import { transformRegisterCertification } from 'front-office/components/register-certification/utils/transform-register-certification';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { toast } from 'react-toastify';

const RegisterCertificationEdit = (): React.ReactElement => {
  const params = useParams();

  const [registerCertification] = useHttpFetch<
    HttpResponse<RegisterCertification>,
    RegisterCertificationForm
  >(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-registro/${params.id}/ente/${params.institution}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformRegisterCertification,
    }
  );

  const updateregisterCertification = useHttpClient(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-registro/${params.id}/ente/${params.institution}`,
    {
      options: {
        errorCatching: true,
        method: 'PUT',
        loading: true,
        data: {},
      },
    }
  );

  const navigate = useNavigate();

  const onOk = (form: RegisterCertificationForm | undefined) => {
    (
      updateregisterCertification({
        data: {
          sigla: form?.initials,
          descrizione: form?.description,
          key: {
            codice: form?.type,
          },
        },
      }) as ResponsePromise<void, void>
    ).then(() => {
      toast.success('Operazione eseguita con successo');
      navigate('/sportello/ricerca-registro');
    });
  };

  return (
    <Fragment>
      <Breadcrumbs items={[...RegisterCertificationCrumbs, { name: 'Modifica Registro' }]} />
      <Form
        onOk={onOk}
        onCancel={() => {
          navigate('/sportello/ricerca-registro');
        }}
        title="Modifica Registro"
        initialValues={registerCertification.data as RegisterCertificationForm}
        mode="EDIT"
      />
    </Fragment>
  );
};

RegisterCertificationEdit.displayName = 'Register certification edit page component';

export default RegisterCertificationEdit;
